// extracted by mini-css-extract-plugin
export default {"admission_wrapper":"Admissions_admission_wrapper__R1sZg"};